import { createAction } from 'typesafe-actions';
import { AlbumlOption, Album } from '@lib/domain/streamingpal';
import { createActionTypePrefixFormat } from '../common';
import { UserInfo, Track } from '../StreamingPals/types';

const typePrefixFormat = createActionTypePrefixFormat('streamingpal');

/* ------------- action creators ------------- */
export const setUserInfo = createAction(
    typePrefixFormat('SET_USER_INFO'),
    (userInfo: UserInfo) => ({
        userInfo,
    }), // payload creator
)();

export const setListAlbum = createAction(
    typePrefixFormat('SET_LIST_ALBUM'),
    (listAlbum: Album[]) => ({
        listAlbum,
    }), // payload creator
)();

export const setUrlAlbumSelected = createAction(
    typePrefixFormat('SET_URL_ALBUM_SELECTED'),
    (urlAlbum: string, currentAlbum: AlbumlOption) => ({
        urlAlbum,
        currentAlbum,
    }), // payload creator
)();

export const setTracks = createAction(
    typePrefixFormat('SET_TRACKS'),
    (tracks: Track[]) => ({
        tracks,
    }), // payload creator
)();
export const setAlbumType = createAction(
    typePrefixFormat('SET_ALBUM_TYPE'),
    (albumType: string) => ({
        albumType,
    }),
)();
export const reset = createAction(typePrefixFormat('RESET'))();

export type StreamingPalActions = ReturnType<
    | typeof setUserInfo
    | typeof setListAlbum
    | typeof setUrlAlbumSelected
    | typeof setTracks
    | typeof reset
    | typeof setAlbumType
>;
